<div class="row">
  <div class="col-12">
    <div class="content-header">{{ isEditMode ? 'Edit Student Pipeline' : 'Student Pipeline Form' }}</div>
  </div>
</div>

<!-- Basic Inputs start -->
<section id="basic-input">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">{{ isEditMode ? 'Edit Student Pipeline' : 'Add Student Pipeline' }}</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <form [formGroup]="pipelineForm">
                  
                  <!-- Name Field -->
                  <fieldset class="form-group">
                    <label for="name">Name <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="name"
                      id="name"
                      placeholder="Enter name"
                      [ngClass]="{
                        'is-invalid': pipelineFormSubmitted && pf.name.invalid,
                        'is-valid': pipelineFormSubmitted && !pf.name.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="pf.name.touched && pf.name.errors?.required"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Name is required
                    </div>
                  </fieldset>

                  <!-- Email Field -->
                  <fieldset class="form-group">
                    <label for="email">Email <span class="text-danger">*</span></label>
                    <input
                      type="email"
                      class="form-control"
                      formControlName="email"
                      id="email"
                      placeholder="Enter email"
                      [ngClass]="{
                        'is-invalid': pipelineFormSubmitted && pf.email.invalid,
                        'is-valid': pipelineFormSubmitted && !pf.email.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="pf.email.touched && pf.email?.errors?.required"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Email is required
                    </div>
                    <div
                      *ngIf="pf.email.errors?.email"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Please enter a valid email address
                    </div>
                  </fieldset>

                  <!-- Phone Field -->
                  <fieldset class="form-group">
                    <label for="phone">Phone <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      mask="(000) 000-0000"
                      formControlName="phone"
                      class="form-control"
                      id="phone"
                      placeholder="e.g. (555) 555-5555"
                      [ngClass]="{
                        'is-invalid': pipelineFormSubmitted && pf.phone.invalid,
                        'is-valid': pipelineFormSubmitted && !pf.phone.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="pf.phone.touched && pf.phone.errors?.required"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Phone is required
                    </div>
                  </fieldset>

                  <!-- Interested In Field -->
                  <fieldset class="form-group">
                    <label for="interested_in">Interested In <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="interested_in"
                      id="interested_in"
                      placeholder="Enter what they're interested in"
                      [ngClass]="{
                        'is-invalid': pipelineFormSubmitted && pf.interested_in.invalid,
                        'is-valid': pipelineFormSubmitted && !pf.interested_in.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="pf.interested_in.touched && pf.interested_in.errors?.required"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> This field is required
                    </div>
                  </fieldset>

                  <!-- Status Field -->
                  <fieldset class="form-group">
                    <label for="status">Status <span class="text-danger">*</span></label>
                    <ng-select
                      [items]="statusList"
                      bindLabel="name"
                      bindValue="_id"
                      placeholder="Select Status"
                      [(ngModel)]="selectedStatus"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="onStatusChange($event)"
                      [appendTo]="'body'"
                    ></ng-select>
                    <div
                      *ngIf="pipelineFormSubmitted && !selectedStatus"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Status is required
                    </div>
                  </fieldset>

                
                  <!-- Notes Field -->
                  <fieldset class="form-group">
                    <label for="notes">Notes</label>
                    <textarea
                      formControlName="notes"
                      id="notes"
                      rows="3"
                      class="form-control"
                      placeholder="Enter any notes"
                    ></textarea>
                  </fieldset>

                </form>
              </div>

              <div class="col-md-6">
                <form [formGroup]="pipelineForm">

                  <!-- Timeline Month & Year -->
                  <fieldset class="form-group">
                    <label for="timeline_month">Timeline Month & Year</label>
                    <input
                      type="month"
                      class="form-control"
                      id="timeline_month"
                      [(ngModel)]="selectedDate"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="onDateChange($event)"
                      placeholder="Select Month & Year"
                    />
                    <small class="form-text text-muted">Select month and year for the timeline</small>
                  </fieldset>

                 
                  <!-- Courses Field (Multiple) -->
                  <fieldset class="form-group">
                    <label for="course_ids">Courses</label>
                    <ng-select
                      [items]="courseList"
                      bindLabel="name"
                      bindValue="_id"
                      [multiple]="true"
                      [closeOnSelect]="false"
                      placeholder="Select Courses"
                      [(ngModel)]="selectedCourses"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="onCoursesChange($event)"
                      [appendTo]="'body'"
                    ></ng-select>
                  </fieldset>

                  <!-- Events Field (Multiple) -->
                  <fieldset class="form-group">
                    <label for="events_id">Events</label>
                    <ng-select
                      [items]="eventsList"
                      bindLabel="name"
                      bindValue="_id"
                      [multiple]="true"
                      [closeOnSelect]="false"
                      placeholder="Select Events"
                      [(ngModel)]="selectedEvents"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="onEventsChange($event)"
                      [appendTo]="'body'"
                    ></ng-select>
                  </fieldset>

                </form>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="row">
              <div class="col-12">
                <div class="form-actions right">
                  <button
                    type="button"
                    class="btn btn-warning mr-1"
                    (click)="back()"
                  >
                    <i class="ft-x"></i> Cancel
                  </button>
                  <button
                    type="submit"
                    class="btn btn-primary"
                    (click)="submitForm()"
                  >
                    <i class="ft-check-circle"></i> {{ isEditMode ? 'Update' : 'Save' }}
                  </button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>

